'use strict';

var _slicedToArray = require("/builds/SimplyFinServices/rml/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require('react'),
    useState = _require.useState,
    useEffect = _require.useEffect;

var _throttle = require('lodash.throttle');

var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {}

var getPosition = function getPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var defaultOptions = {
  throttle: 100
};

function useWindowScrollPosition(options) {
  var opts = Object.assign({}, defaultOptions, options);

  var _useState = useState(getPosition()),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  useEffect(function () {
    var handleScroll = _throttle(function () {
      setPosition(getPosition());
    }, opts.throttle);

    window.addEventListener('scroll', handleScroll, supportsPassive ? {
      passive: true
    } : false);
    return function () {
      handleScroll.cancel();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return position;
}

module.exports = useWindowScrollPosition;